<template>
  <section class="bg-color-gray--50">
    <AlertRecuseTerms
      v-if="showRejectDialog"
      @close="closeReject"
      @reject="rejectTerms"
    />
    <div class="container gap-32 termos__container">
      <div class="termos__header">
        <img src="../../public/images/logo-box-main.svg" width="170px"/>
        <h1 class="termos__title">
          Termos de uso
        </h1>
        <span class="termos__date-terms-accepted" v-if="store.termsAccepted">
          Aceito em: {{
            new Intl.DateTimeFormat('pt-BR').format(store.termsAcceptedAt)
          }}
        </span>
      </div>

      <ConteudoTermosDeUso/>
    </div>
    <div class="termos__footer" v-if="!store.termsAccepted">
      <button class="termos__text-button" @click="acceptTerms" v-if="showAcceptedButton">
        Aceito os termos de serviço
      </button>
      <button class="termos__recuse" @click="confirmReject" v-if="showRejectButton">
        Recusar
      </button>
    </div>
    <div class="termos_footer-terms-accepted" v-else>
      <a class="termos__button-back-app" :href="store.links.backToApp">
        Voltar ao app
      </a>
    </div>
  </section>
</template>

<script setup>
import AlertRecuseTerms from "./components/AlertRecuseTerms.vue";
import ConteudoTermosDeUso from './components/ConteudoTermosDeUso.vue';
import { useStore } from '@/stores/termosDeUso';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import Swal from 'sweetalert2';

const props = defineProps({
  showAcceptedButton: {
    type: Boolean,
    default: true, 
  },
  showRejectButton: {
    type: Boolean,
    default: true, 
  }
});

const router = useRouter();
const store = useStore();

const showRejectDialog = ref(false);

function confirmReject() {
  showRejectDialog.value = true;
}

function closeReject() {
  showRejectDialog.value = false;
}

function errorAlert() {
  return Swal.fire({
    titleText: 'Ops! Algo deu errado.',
    text: 'Tente novamente em instantes.',
    icon: 'error',
  });
}

async function acceptTerms() {
  Swal.fire({
    text: 'Registrando seu aceite',
    allowOutsideClick: false,
  }).then();
  Swal.showLoading();

  try {
    await store.acceptTerms();
  } catch (e) {
    Swal.hideLoading();
    await errorAlert();
    return;
  }

  Swal.close();
  router.push('/concluido')
}

async function rejectTerms() {
  Swal.fire({
    text: 'Registrando sua recusa',
    allowOutsideClick: false,
  });
  Swal.showLoading();

  try {
    await store.rejectTerms();
  } catch (e) {
    Swal.hideLoading();
    await errorAlert();
    return;
  }

  Swal.close();
  router.push('/recusado');
}

</script>
